<div class="title">
  {{ 'raportit.tase' | translate | async }}
</div>
@if (taseDataObservable | async; as data) {
  @if (!lataa()) {
    @if (data.e == 'a') {
      <div>
        {{ 'raportit.valittu-paivamaara-ei-tilikaudella' | translate | async }}
      </div>
    }
    @if (lastSuccessfullyUpdated()) {
      <div class="gray-text" style="font-size: 11px; text-align: right; line-height: 13px">{{ 'yleiset.paivitetty' | translate | async }} {{ lastSuccessfullyUpdated() | ltimestamptime | async }}</div>
    }
    @if (data.c == 'c2') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>{{ data.c1.e | lnumberpvml: 'fi' }}</td>
            <td>{{ data.c2.e | lnumberpvml: 'fi' }}</td>
            <td>{{ 'raportit.muutos' | translate | async }}</td>
          </tr>
        </thead>
        @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
          <tbody>
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
              <td>{{ row.s2 | lmoney | async }}</td>
              <td>{{ row.m | lmoney | async }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="4">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="4">
                  <table>
                    <thead>
                      <tr>
                        <td>{{ 'raportit.laji' | translate | async }}</td>
                        <td>{{ 'raportit.tosite' | translate | async }}</td>
                        <td>{{ 'raportit.pvm' | translate | async }}</td>
                        <td>{{ 'raportit.selite' | translate | async }}</td>
                        <td>{{ 'raportit.alv' | translate | async }}</td>
                        <td>{{ 'raportit.debet' | translate | async }}</td>
                        <td>{{ 'raportit.kredit' | translate | async }}</td>
                        <td>{{ 'raportit.saldo' | translate | async }}</td>
                      </tr>
                      <tr class="alkusaldo">
                        <td></td>
                        <td></td>
                        <td colspan="2">{{ 'raportit.alkusaldo' | translate | async }}</td>
                        <td colspan="4" [attr.data-a]="row.a" class="ah" [class.blue-link-text]="row.o1">{{ row.o1 | lmoney | async }}</td>
                      </tr>
                      <tr style="display: none">
                        <td colspan="8">
                          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </td>
                      </tr>
                    </thead>
                    <tbody [attr.data-n]="row.n">
                      @for (d of row.d; track d; let i = $index) {
                        <tr [attr.data-i]="i">
                          <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                          <td [attr.data-n]="d.n">{{ d.n }}</td>
                          <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                          <td>
                            @if (d.a) {
                              <span class="blue-text space-after">{{ d.a }}</span>
                            }
                            @if (d.c) {
                              <span class="cursive-text space-after">{{ d.c }}</span>
                            }
                            {{ d.r }} {{ d.e }}
                          </td>
                          <td>{{ d.v }}</td>
                          <td>{{ d.d | lmoney | async }}</td>
                          <td>{{ d.k | lmoney | async }}</td>
                          <td>{{ d.s | lmoney | async }}</td>
                        </tr>
                      }
                      <tr class="loppusaldo">
                        <td></td>
                        <td></td>
                        <td colspan="2">{{ 'raportit.yhteensa' | translate | async }}</td>
                        <td></td>
                        <td>{{ row.dds | lmoney | async }}</td>
                        <td>{{ row.dks | lmoney | async }}</td>
                        <td>{{ row.dss | lmoney | async }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    }
    @if (data.c == 'c1') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td>{{ data.c1?.e | lnumberpvml: 'fi' }}</td>
          </tr>
        </thead>
        @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
          <tbody>
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }}" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | lmoney | async }}</td>
            </tr>
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="2">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <tr class="report-row-lvl-{{ row.l }}">
                <td colspan="2">
                  <table>
                    <thead>
                      <tr>
                        <td>{{ 'raportit.laji' | translate | async }}</td>
                        <td>{{ 'raportit.tosite' | translate | async }}</td>
                        <td>{{ 'raportit.pvm' | translate | async }}</td>
                        <td>{{ 'raportit.selite' | translate | async }}</td>
                        <td>{{ 'raportit.alv' | translate | async }}</td>
                        <td>{{ 'raportit.debet' | translate | async }}</td>
                        <td>{{ 'raportit.kredit' | translate | async }}</td>
                        <td>{{ 'raportit.saldo' | translate | async }}</td>
                      </tr>
                      <tr class="alkusaldo">
                        <td></td>
                        <td></td>
                        <td colspan="2">{{ 'raportit.alkusaldo' | translate | async }}</td>
                        <td colspan="4" [attr.data-a]="row.a" class="ah" [class.blue-link-text]="row.o1">{{ row.o1 | lmoney | async }}</td>
                      </tr>
                      <tr style="display: none">
                        <td colspan="8">
                          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                        </td>
                      </tr>
                    </thead>
                    @if (row.d.length > 0) {
                      <tbody [attr.data-n]="row.n">
                        @for (d of row.d; track d; let i = $index) {
                          <tr [attr.data-i]="i">
                            <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null">{{ d.ma }}</td>
                            <td [attr.data-n]="d.n">{{ d.n }}</td>
                            <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                            <td>
                              @if (d.a) {
                                <span class="blue-text space-after">{{ d.a }}</span>
                              }
                              @if (d.c) {
                                <span class="cursive-text space-after">{{ d.c }}</span>
                              }
                              {{ d.r }} {{ d.e }}
                            </td>
                            <td>{{ d.v }}</td>
                            <td>{{ d.d | lmoney | async }}</td>
                            <td>{{ d.k | lmoney | async }}</td>
                            <td>{{ d.s | lmoney | async }}</td>
                          </tr>
                        }
                        <tr class="loppusaldo">
                          <td></td>
                          <td></td>
                          <td colspan="2">{{ 'raportit.yhteensa' | translate | async }}</td>
                          <td></td>
                          <td>{{ row.dds | lmoney | async }}</td>
                          <td>{{ row.dks | lmoney | async }}</td>
                          <td>{{ row.dss | lmoney | async }}</td>
                        </tr>
                      </tbody>
                    }
                  </table>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    }
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}
